module.exports = __webpack_public_path__ + "static/media/school-admin-icon.3e279dd8.png";